import { ViewExportSchema } from "@redotech/redo-model/views/view-exports";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const watchViewExportProgress = unaryStreamRpc({
  name: "watchViewExportProgress",
  input: z.object({
    viewExportIds: z.array(z.string()),
  }),
  output: z.object({ viewExport: ViewExportSchema }),
});
